import { Link } from "react-router-dom";
import { AlertTriangle, ShoppingCart } from "lucide-react";
import { useCart } from "@/context/CartContext";

export default function PaymentCancel() {
  const { setOpen } = useCart();
  return (
    <div className="max-w-xl mx-auto px-5 py-24 text-center" data-testid="payment-cancel">
      <AlertTriangle size={56} className="mx-auto text-red-500" />
      <h1 className="tms-title text-5xl mt-6">Pagamento annullato</h1>
      <p className="text-zinc-400 mt-4">Nessun addebito effettuato. Il tuo carrello è ancora qui, pronto quando vuoi.</p>
      <div className="flex flex-wrap gap-4 justify-center mt-8">
        <button className="btn-red" onClick={() => setOpen(true)} data-testid="cancel-open-cart-button"><ShoppingCart size={18} /> Torna al carrello</button>
        <Link to="/servizi" className="btn-ghost" data-testid="cancel-services-link">Servizi</Link>
      </div>
    </div>
  );
}
